import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'

const ManageAudioCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, id: null });
  const navigate = useNavigate();

  // Get auth token from localStorage
  const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  };

  const fetchCategories = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/audio-genres`, {
        headers: getAuthHeaders(),
        params: { page }
      });
      
      if (response.data.status) {
        setCategories(response.data.AllAudioGenre || response.data.data || []);
        setCurrentPage(response.data.pagination?.currentPage || page);
        setTotalPages(response.data.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error('Error fetching audio categories:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Baseurl}/admin/audio-genres/${id}`, {
        headers: getAuthHeaders()
      });
      
      if (response.data.status) {
        alert('Audio category deleted successfully!');
        fetchCategories(currentPage); // Refresh current page
      } else {
        alert('Failed to delete audio category');
      }
    } catch (error) {
      console.error('Error deleting audio category:', error);
      alert('Error deleting audio category');
    }
    setDeleteConfirm({ show: false, id: null });
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      fetchCategories(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      fetchCategories(currentPage + 1);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const renderCategoryRow = (item, level = 0, idxString) => {
    return (
      <React.Fragment key={item.id}>
        <tr className="text-center">
          <td>{idxString}</td>
          <td className="text-start" style={{ paddingLeft: `${level * 2 + 1}rem` }}>
            <img 
              src={item.image || item.image_url || '/default-category.png'} 
              width="100px" 
              height="80px"
              alt={item.name}
              onError={(e) => {
                e.target.src = '/default-category.png';
              }}
            />
          </td>
          <td className="text-start" style={{ paddingLeft: `${level * 2 + 1}rem` }}>
            <strong>{level > 0 ? `↳ ${item.name}` : item.name}</strong>
            {item.upload_on && (
              <><br/><small className="text-muted">{item.upload_on}</small></>
            )}
          </td>
          <td>
            <span className="badge bg-secondary">
              {item.uploaded_by_name || 'Admin'}
            </span>
          </td>
          <td>
            <div className="btn-group" role="group">
              <Link
                to={`/admin/edit-audio-categories/${item.id}`}
                className="btn btn-sm btn-outline-primary"
                title="Edit"
              >
                <i className="fa fa-pencil-square" aria-hidden="true"></i>
              </Link>
              <button 
                className="btn btn-sm btn-outline-danger"
                onClick={() => setDeleteConfirm({ show: true, id: item.id })}
                title="Delete"
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
        {item.sub_categories && item.sub_categories.length > 0 && item.sub_categories.map((sub, idx) => 
          renderCategoryRow(sub, level + 1, `${idxString}.${idx + 1}`)
        )}
      </React.Fragment>
    );
  };

  return (
    <div>
        <div className=" m-0 p-0">
        <div className="">
          <section className="section container-fluid">
            <div className=" pt-3">
              <div className="row">
                <div className="col-sm-12">
                  <div className="iq-card">
                    <div className="iq-card-header d-flex justify-content-between mb-4 align-items-baseline">
                      <div className="iq-header-title">
                        <h4 className="card-title">Audio Category</h4>
                      </div>
                      <div className="iq-card-header-toolbar d-flex align-items-center">
                        <Link
                          to="/admin/channel/add-category"
                          className="btn btn-primary"
                        >
                          <i className="fa fa-plus-circle me-1"></i>
                          Add Audio Categories
                        </Link>
                      </div>
                    </div>
                    <div className="">
                      <div className="table-view p-0">
                        {loading ? (
                          <div className="text-center py-4">
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p>Loading audio categories...</p>
                          </div>
                        ) : (
                          <table
                            className="table table-bordered iq-card text-center"
                            id="categorytbl"
                          >
                            <thead>
                              <tr className="text-center r1">
                                <th>
                                  <label>S.No</label>
                                </th>
                                <th>
                                  <label>Image</label>
                                </th>
                                <th>
                                  <label>Name</label>
                                </th>
                                <th>
                                  <label>Uploaded by</label>
                                </th>
                                <th>
                                  <label>Actions</label>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {categories.length > 0 ? (
                                categories.map((item, key) => renderCategoryRow(item, 0, (key + 1).toString()))
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center py-4">
                                    <p className="mb-0">No audio categories found</p>
                                    <small className="text-muted">Click 'Add Audio Categories' to create your first category</small>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}

                        {/* Pagination */}
                        <div className="row text-center d-flex mt-3">
                          <div className="col-lg-4">
                            <button
                              type="button"
                              className={`btn btn-primary ${currentPage <= 1 ? 'disabled' : ''}`}
                              onClick={handlePrevClick}
                              disabled={currentPage <= 1}
                            >
                              {"<< Previous"}
                            </button>
                          </div>
                          <div className="col-lg-4">
                            <p className="mb-0">
                              Page {currentPage} of {totalPages}
                            </p>
                          </div>
                          <div className="col-lg-4">
                            <button
                              type="button"
                              className={`btn btn-primary ${currentPage >= totalPages ? 'disabled' : ''}`}
                              onClick={handleNextClick}
                              disabled={currentPage >= totalPages}
                            >
                              {"Next >>"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirm.show && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setDeleteConfirm({ show: false, id: null })}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this audio category? This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setDeleteConfirm({ show: false, id: null })}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger" 
                  onClick={() => handleDelete(deleteConfirm.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ManageAudioCategories